import axios from "axios";
import authentication from "@/authentication";
export default {
  baseUrl: process.env.VUE_APP_API_CALAMITY_SERVICE_BASE,
  async create(calamity) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/Create`, JSON.stringify(calamity), {
        headers: { Authorization: `Bearer ${authentication.getToken()}` }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadPotential() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetPotentialReport`, {
        headers: { Authorization: `Bearer ${authentication.getToken()}` }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadPotentialPackages(hashKey) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetPotentialPackagesReport?hashKey=${hashKey}`, {
        headers: { Authorization: `Bearer ${authentication.getToken()}` }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadSelectedPotential(hashKey) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetSelectedPotential?hashKey=${hashKey}`, {
        headers: { Authorization: `Bearer ${authentication.getToken()}` }
      })
      .then(response => {
        return response.data;
      });
  },
  async SendTrackRequest(packages) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/SendTrackRequest`, packages, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  }
};
